import { initDynamicClassTypes } from '@/scripts/optional/dynamic-class-types';

document.addEventListener('DOMContentLoaded', (): void => initDynamicClassTypes());
